var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 m-0 p-0"},[_c('iframe',{attrs:{"src":_vm.sidekiqUrl,"frameBorder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }